import React from 'react'
import useMediaQuery from 'use-mediaquery'
import HeaderTracking from '../components/Header/HeaderTracking/HeaderTracking'
import HeaderTrackingMobile from '../components/Header/HeaderTrackingMobile/HeaderTracking'
import "./TrackingLayout.scss"

const TrackingLayout = ({ children }) => {
    const matches = useMediaQuery('(min-width: 768px)')
    return (
        <div className='tracking-layout'>
            {matches ? (
                <div className="d-none d-md-block sticky-top">
                    <HeaderTracking />
                </div>
            ) : (
                <div className="d-block d-md-none sticky-top">
                    <HeaderTrackingMobile />
                </div>
            )}
            <div className="tracking-main">
                <div className="tracking-content">{children}</div>
            </div>
        </div>
    )
}

export default TrackingLayout